import { ROUND_COUNT } from "../color";
import { copy } from "../copy";

export function Scoreboard({ resultsCount, total, average, best }: {
  resultsCount: number;
  total: number;
  average: number;
  best: number;
}) {
  return (
    <section className="scoreboard" aria-label="점수판">
      <div>
        <span>{copy.total}</span>
        <strong>{total}</strong>
      </div>
      <div>
        <span>{copy.average}</span>
        <strong>{average}</strong>
      </div>
      <div>
        <span>{copy.round}</span>
        <strong>{resultsCount}/{ROUND_COUNT}</strong>
      </div>
      <div>
        <span>{copy.bestScore}</span>
        <strong>{best}</strong>
      </div>
    </section>
  );
}
